import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Stylesheets/Timeline.css";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";

export default function Timeline() {
  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  const navigate = useNavigate();
  const toggleItem = (path) => {
    navigate(path);
  };
  const timelineItems = [
  {
    title: "Month 1: Orientation and Foundation",
    duration: "1 month",
    description:
      "Introduction to company policies, discipline, trial sessions, setup of development environment, and foundation in chosen technology stack.",
    badges: [
      "Company Policies & Discipline",
      "Trial Session",
      "Development Environment Setup",
      "Technology Fundamentals"
    ],
    path: "/month1",
  },
  {
    title: "Month 2: Core Training",
    duration: "1 month",
    description:
      "Domain-specific hands-on sessions, dummy projects, real-time coding practice, and continuous discipline evaluation with weekly feedback.",
    badges: [
      "Hands-On Domain Training",
      "Dummy Projects",
      "Real-Time Coding Practice",
      "Discipline Evaluation"
    ],
    path: "/month2",
  },
  {
    title: "Month 3: Mini Assignments and Discipline Check",
    duration: "1 month",
    description:
      "Focus on small coding tasks, debugging exercises, weekly discipline scoring, and mid-review feedback sessions for both technical and behavioral improvement.",
    badges: [
      "Coding Tasks",
      "Debugging Exercises",
      "Weekly Discipline Scoring",
      "Mid-Review Session"
    ],
    path: "/month3",
  },
  {
    title: "Month 4: Mini Project (Part 1)",
    duration: "1 month",
    description:
      "Kick-off of mini project with emphasis on teamwork, collaboration, project documentation, and midway presentation to track progress.",
    badges: [
      "Project Kick-Off",
      "Team Collaboration",
      "Documentation",
      "Midway Presentation"
    ],
    path: "/month4",
  },
  {
    title: "Month 5: Mini Project (Part 2) + Mock Interview",
    duration: "1 month",
    description:
      "Completion of mini project with testing and optimization, followed by mock technical and HR interviews to prepare for employment readiness.",
    badges: [
      "Project Completion",
      "Testing & Debugging",
      "Optimization",
      "Mock Interviews"
    ],
    path: "/month5",
  },
  {
    title: "Month 6: Final Evaluation",
    duration: "1 month",
    description:
      "Final project presentation and evaluation based on technical skills, discipline, communication, and teamwork, leading to employment phase eligibility.",
    badges: [
      "Final Project Presentation",
      "Evaluation Parameters",
      "Results & Transition",
      "Employment Eligibility"
    ],
    path: "/month6",
  },
];


  return (
    <section
      id="timeline"
      className="py-5 position-relative"
    >
      {/* Background video */}
      {/* <div className="program-bg  d-flex align-items-center">
        <video loop autoPlay muted playsInline>
          <source src="https://www.pexels.com/download/video/19419586/" />
        </video>
        <div className="video-overlay"></div>
      </div> */}

      <div className="container-fluid poistion-relative">
        {/* Section Heading */}
        <div className="row mb-5 position-relative">
          <div className="col-lg-8 mx-auto text-center">
            <h1 className="fw-bold gradient-text " style = {{fontFamily:"'Merriweather', serif"}} >
              Program Timeline
            </h1>
            <p
              className="fs-5 mt-5"
              style={{ color: "rgba(237, 240, 241, 1)" }}
            >
              A structured 6-month training and 1-year Job Guaranteed journey
              from beginner to Expertised IT Professional.
            </p>
          </div>
        </div>

        {/* Timeline Items */}
        <div className="row">
          <div className="col-lg-8 mx-auto ">
            {timelineItems.map((item, index) => (
              <div
                key={index}
                className="mb-4 timeline-item "
                data-aos="flip-up"
              >
                <div className=" shadow p-4 card-custom1">
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <h4 className=" mb-0"style={{ color: "rgb(7, 223, 252)" }}>{item.title}</h4>
                    <span
                      className={`badge ${
                        item.isSuccess ? "bg-success" : "bg-secondary"
                      } me-2`}
                    >
                      {item.duration}
                    </span>
                  </div>

                  <div className="ms-auto d-flex flex-wrap">
                    {" "}
                    <p className="text-light mb-3">{item.description}</p>
                    <button
                      className="ms-auto btn-primary-custom text-light"
                      onClick={() => toggleItem(item.path)}
                    >
                      Read More
                    </button>
                  </div>
                  <div className="d-flex flex-wrap gap-2">
                    {item.badges &&
                      item.badges.map((badge, badgeIndex) => (
                        <span key={badgeIndex} className="badge bg-secondary">
                          {badge}
                        </span>
                      ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
